<div class="col-sm-12 p-0">
  <div class="col-sm-12 pl-1">
    <h3 class="math-auto mt-1"> Liste des utilisateurs connectés </h3>
  </div>
  <div class="col-sm-12 p-0 d-flex">
    <div class="col-sm-4" style="padding: 0;">
      <span class="input-group recherche" style="padding: 2px 1px">
        <input class="form-control" (keydown.enter)="searchHandle()" style=" height: 35px" [(ngModel)]="search"
          [ngClass]="{'focus focusBorderRight': focus}" type="search" (focus)="focus = !focus" (blur)="focus = !focus"
          placeholder="Rechercher">
        <span class="input-group-addon " id="basic-addon1" [ngClass]="{'focus focusBorderLeft': focus}" (click)="searchHandle()">
          <span class="glyphicon glyphicon-search"></span>
        </span>
      </span>
    </div>
    <div class="col-sm-8 text-right mb-2" style="padding-right: 0;">
      <button class="btn btn-valider uppercase" id="valide" (click)="exportXLS()">
        Exporter le tableau en XLS
       </button>
    </div>
  </div>
</div>

<div class="tab col-sm-12 p-0">
  <ngx-datatable  class="material document" [rows]="rows" [columnMode]="'force'" [headerHeight]="40"
    [footerHeight]="0" [rowHeight]="30" [selectionType]="'single'"
    [messages]="{emptyMessage: loadingIndicator ? 'Chargement ...' : 'Pas de lignes à afficher'}"
    [loadingIndicator]="loadingIndicator">
    <ngx-datatable-column prop="login">
      <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
        let-sort="sortFn">
        <div class="tableheader" (click)="sort()">
          <span class="uppercase"> Login </span>
          <div class=" col-sm-1 pull-right">
            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
          </div>
        </div>
      </ng-template>
      <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
        <div class="strong">
          {{value}}
        </div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="dateConnexion">
      <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
        let-sort="sortFn">
        <div class="tableheader" (click)="sort()">
          <span class="uppercase"> Date Connex </span>
                   <div class=" col-sm-1 pull-right">
            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
          </div>
        </div>
      </ng-template>
      <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
        <div class="strong">
          {{value}}
        </div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="heureConnexion">
      <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
        let-sort="sortFn">
        <div class="tableheader" (click)="sort()">
          <span class="uppercase"> Heure Connex </span>
                   <div class=" col-sm-1 pull-right">
            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
          </div>
        </div>
      </ng-template>
      <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
        <div class="strong">
          {{value}}
        </div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="dateUpdate">
      <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
        let-sort="sortFn">
        <div class="tableheader" (click)="sort()">
          <span class="uppercase"> Date MAJ </span>
                   <div class=" col-sm-1 pull-right">
            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
          </div>
        </div>
      </ng-template>
      <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
        <div class="strong">
          {{value}}
        </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column prop="heureUpdate">
      <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
        let-sort="sortFn">
        <div class="tableheader" (click)="sort()">
          <span class="uppercase"> Heure MAJ </span>
                   <div class=" col-sm-1 pull-right">
            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
          </div>
        </div>
      </ng-template>
      <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
        <div class="strong">
          {{value}}
        </div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="dateLastModifFr">
      <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
        let-sort="sortFn">
        <div class="tableheader" (click)="sort()">
          <span class="uppercase"> Date der. modif </span>
                   <div class=" col-sm-1 pull-right">
            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
          </div>

        </div>
      </ng-template>
      <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
        <div class="strong">
          {{value}}
        </div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="lastLogModification.nomTableEcorec">
      <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
        let-sort="sortFn">
        <div class="tableheader" (click)="sort()">
          <span class="uppercase"> Type der. modif </span>
        </div>
      </ng-template>
      <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
        <div class="strong">
          {{value}}
        </div>
      </ng-template>
    </ngx-datatable-column>

  </ngx-datatable>
</div>


<ng-template #msg>
    <div class="modal-body" style="height: auto">
        <div>
            <div class="col-sm-12">
                <label class="cofirmemsg" [innerHTML]="error"> </label>
            </div>
        </div>
        <div class="text-right" style="margin-top: 15px;">
            <button type="button" class=" btn-close btn-valider" (click)="error = ''; common.closeModal()"> Fermer
            </button>
        </div>
    </div>
</ng-template>